import { render, staticRenderFns } from "./LearnStatusWrongQuestionTile.vue?vue&type=template&id=2e86993a&"
import script from "./LearnStatusWrongQuestionTile.vue?vue&type=script&lang=ts&"
export * from "./LearnStatusWrongQuestionTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports